export { getIosModalPresentationConfig } from './getIosModalPresentationConfig';
